(() => {
  if (!customElements.get("search-clear")) {
    class t extends HTMLElement {
      constructor() {
        super(), this.initializeProperties(), this.bindMethods(), this.attachEventListeners(), 
        this.init();
      }
      initializeProperties() {
        this.form = this.querySelector("form") || this.closest("form"), this.input = this.form?.querySelector('input[name="q"]') || this.querySelector('input[name="q"]'), 
        this.clearButtons = this.querySelectorAll("[data-clear]"), this.form && this.input || console.warn("SearchClear: Required form elements not found");
      }
      bindMethods() {
        this.handleClear = this.handleClear.bind(this), this.handleInput = this.handleInput.bind(this), 
        this.updateClearButtonVisibility = this.updateClearButtonVisibility.bind(this);
      }
      attachEventListeners() {
        this.clearButtons?.forEach(t => {
          t.addEventListener("click", this.handleClear);
        }), this.input?.addEventListener("input", this.handleInput), this.form?.addEventListener("reset", () => {
          requestAnimationFrame(() => {
            this.updateClearButtonVisibility();
          });
        });
      }
      handleInput(t) {
        this.updateClearButtonVisibility();
      }
      handleClear(t) {
        t.preventDefault(), t.stopPropagation(), this.input && (this.input.value = "", this.input.focus(), 
        this.input.dispatchEvent(new Event("input", {
          bubbles: !0
        }))), this.updateClearButtonVisibility();
      }
      updateClearButtonVisibility() {
        if (!this.clearButtons || 0 === this.clearButtons.length) return;
        const t = this.getSearchQuery().length > 0;
        this.clearButtons.forEach(e => {
          t ? (e.classList.remove("opacity-0", "pointer-events-none"), e.classList.add("pointer-events-auto")) : (e.classList.add("opacity-0", "pointer-events-none"), 
          e.classList.remove("pointer-events-auto"));
        });
      }
      getSearchQuery() {
        return this.input?.value?.trim() || "";
      }
      init() {
        this.updateClearButtonVisibility();
      }
      disconnectedCallback() {
        this.clearButtons?.forEach(t => {
          t.removeEventListener("click", this.handleClear);
        }), this.input?.removeEventListener("input", this.handleInput);
      }
    }
    customElements.define("search-clear", t);
  }
})();